import React from "react";

import { Helmet } from "react-helmet";

export default function MetaDecorator() {
  return (
    <Helmet>
      <title>Zdravstvene ustanove | Udruga Roda</title>
      <meta
        name="description"
        content="Portal o roditeljstvu udruge Roda. Omogućava bolju podršku trudnicama i obiteljima koja će olakšati cijeli proces trudnoće i poroda kroz bližnju suradnju s rodilištima."
      />
    </Helmet>
  );
}
